import React, { useState, useCallback } from "react";
import { Box } from '@chakra-ui/react';
import { DetailedItemDataSuggestionGrid } from "components";
import { useDetailedStatusItemDataSuggestions, useApproveItemDataSuggestion, useRejectItemDataSuggestion } from "hooks/queries/useItemDataSuggestions";
import { useArtists } from "hooks/queries/useArtists";
import { ProcessStatus } from "models/types";

export function ItemDataSuggestionsOverview() {
  const [selectedStatus, setSelectedStatus] = useState<ProcessStatus>(ProcessStatus.PENDING);
  const { data: suggestionsPagination, isLoading } = useDetailedStatusItemDataSuggestions(selectedStatus);
  const { data: artistsData } = useArtists();
  const approveSuggestionMutation = useApproveItemDataSuggestion();
  const rejectSuggestionMutation = useRejectItemDataSuggestion();

  const suggestionList = suggestionsPagination?.data || [];
  const artistsList = artistsData || [];

  const handleStatusChange = (status: ProcessStatus) => {
    setSelectedStatus(status);
  };

  const handleApprove = useCallback((suggestionId: string) => {
    approveSuggestionMutation.mutate({ item_data_suggestion_id: suggestionId });
  }, [approveSuggestionMutation]);

  const handleReject = useCallback((suggestionId: string) => {
    rejectSuggestionMutation.mutate({ item_data_suggestion_id: suggestionId });
  }, [rejectSuggestionMutation]);

  const isActionLoading = approveSuggestionMutation.isPending || rejectSuggestionMutation.isPending;

  return (
    <Box maxWidth="1200px" width="100%" paddingTop={['80px', '100px', '100px']} justifySelf="center" minHeight="100vh" mx="auto">
      <DetailedItemDataSuggestionGrid
        suggestions={suggestionList}
        isLoading={isLoading}
        onApprove={handleApprove}
        onReject={handleReject}
        defaultStatus={selectedStatus}
        onStatusChange={handleStatusChange}
        isActionLoading={isActionLoading}
        availableArtists={artistsList}
      />
    </Box>
  );
}

export default ItemDataSuggestionsOverview;
